module.exports = __webpack_public_path__ + "static/img/04.e8e782a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/04.png
// module id = Ok8K
// module chunks = 2